export default __webpack_public_path__ + "static/media/h3.8c3f0edb.jpg";